<template>
  <div class="crud-action">
    <ul class=" right">
      <li class="content-item edit" v-if="!exclude.includes('duplicate')">
      <div class="value-action-duplicate">
        <i
          class="icon yule-icon-duplicate"
          @click="duplicate"
        />
         <q-tooltip> {{ $t('models.duplicate_action')}} </q-tooltip>
      </div>
      <div class="value-action-pending">
        <i class="icon yule-icon-clock" :title="$t('models.external_form.pending_cloning')"></i>
      </div>

    </li>
      <li class="content-item edit" v-if="!exclude.includes('edit')">
        <router-link :to="editRouteParams" @click.native="outsideClick" :data-action="model + '.edit'" :data-action-id="item.id" class="icon yule-icon-edit">
          <q-tooltip> {{ $t('models.edit_action')}} </q-tooltip>
        </router-link>
      </li>
      <li class="content-item" v-if="!exclude.includes('delete')">
        <modal
        :title="$t('ui.global.delete_title')"
        :content="$t('ui.global.delete_confirmation', {name: item.name})"
        :actions="[
          {name: 'valid', class: 'btn btn-cancel', action: model + '.delete.confirm'},
          {name: 'cancel', class: 'btn btn-tertiary', action: model + '.delete.cancel'}
        ]"
        btn-class=" "
        :data-action="model + '.delete'"
        :data-action-id="item.id"
        @action="action">
          <i class="icon yule-icon-trash">
            <q-tooltip> {{ $t('models.delete_action')}} </q-tooltip>
          </i>
        </modal>

      </li>
    </ul>
  </div>
</template>
<script>
import Modal from '@/components/helpers/Layout/Modal'
import { EventBus } from '@/EventBus.js';

export default {
  props: ['item', 'model', 'column', 'duplicateDescriptionText'],
  components: { Modal },
  computed: {
    renderDuplicateDescriptionText() {
      return this.duplicateDescriptionText || this.$t('models.duplicate_desc');
    },
    showRouteParams(){
      return { name: this.model + '_show' , params: { id: this.item.id } }
    },
    editRouteParams(){
      if (this.model === "project_lead" ) {
        return { name: this.model + '_edit' , params: { project_id: this.item.user_id, lead_id: this.item.id} }
      } else {
        return { name: this.model + '_edit' , params: { id: this.item.id} }
      }
    },
    exclude(){
      if(this.column.exclude){
        return this.column.exclude
      }else{
        return []
      }
    }
  },
  data(){
    return {
      visible: false
    }
  },
  methods: {
    duplicate() {
      let event_name = this.model + '_duplicate'
      // @TODO: add name feature here
      let payload = { id: this.item.id }
      EventBus.$emit(event_name, payload)
    },
    outsideClick(){
      this.visible = false
    },
    toggleVisible(){
      this.visible = !this.visible
    },
    action(name){
      if(name === "valid"){
        this.$emit('itemDelete',this.item)
      }
    }
  }
}
</script>
<style lang="scss">
.value.project-action,
.value.project_lead-action{
  width: 1%;
  padding: 0;
}
.dot-navigation--trigger{
  padding: 10px
}
.crud-action {
  .icon {
    color: $ink-lighter;
    cursor: pointer;
    transition: .15s all ease-out;
    padding: .3em;
    font-size: 1.5em;
    &:hover {
      background-color: $paper-light !important;
      color: $ink-dark !important;
      border-radius: 4px;
      }
    &:active {
      background-color: $sensual-lighter !important;
      color: $sensual !important;
      border-radius: 4px;
      }
  }
  ul {
    list-style: none;
    display: flex;
    flex-direction: row;
    padding-left: 0;
    margin: 0px;
  }
  a {
    text-decoration: none;
  }
  .content-item.edit {
      margin-right: 1.2em;

  }
}
.value-action-pending {
  display: none;
}

</style>



// WEBPACK FOOTER //
// CollectionValueCrudActionFolded.vue?42220ed8